import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import ProtectedRouter from "components/routeGuard";
import Loader from "components/loader";
import TermsOfUse from "components/TermsOfUse";
const Dashboard = lazy(() => import("pages/dashboard"));
const NoAccess = lazy(() => import("pages/noAccess"));


const App = () => {
 
  
  return (
    <Suspense fallback={<Loader loading />}>
      <Router>
        <Routes>
          <Route element={<ProtectedRouter />}>
            <Route
              path="/terms-of-use"
              element={
                <TermsOfUse />
              }
            />
            <Route path="/" element={<Dashboard />} />
            <Route path="*" element={<NoAccess />} />
          </Route>
        </Routes>
      </Router>
    </Suspense>
  );
}

export default App;
